import styled from 'styled-components'

export const ContentUnavailableElem = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  font-weight: 300;
  background-color: rgba(0, 0, 0, 0.1);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  opacity: 1;
  border: 2px solid rgba(255, 255, 255, 0.1);
  box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.1);
  border-radius: 24px;
  overflow: hidden;
`
